import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutJobClassCode extends Layout {
    dataheaderJobClassCode: DataHeader;
    sourceJobClassCodeLookup: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
